import { createContext } from 'react';

// Normalized auth state exposed to the rest of the app, regardless of provider.
// GoogleAdapter populates this shape from the verified Google id_token.
export const AuthContext = createContext(null);
